// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import isNil from 'lodash/isNil'

// Atoms
import Typography from '@material-ui/core/Typography'
import Chip from 'atoms/Chip'

// Components
import ItemEditDialog from './ItemEditDialog'

export default class ScheduleItem extends Component {
  static propTypes = {
    item: PropTypes.shape({
      startTimeMinute: PropTypes.number.isRequired,
      endTimeMinute: PropTypes.number,
      weekDay: PropTypes.number.isRequired,
    }),
    onDelete: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    addFormTitle: PropTypes.string.isRequired,
    editFormTitle: PropTypes.string.isRequired,
  }

  state = {
    dialogOpen: false,
  }

  toggleDialog = () => {
    const { dialogOpen } = this.state
    this.setState({ dialogOpen: !dialogOpen })
  }

  renderTime(minutesFromStartOfDay) {
    return moment().startOf('day').add(minutesFromStartOfDay, 'minutes').format('h:mm a')
  }

  render() {
    const { item, onDelete, onChange, addFormTitle, editFormTitle } = this.props
    const { dialogOpen } = this.state
    return (
      <Fragment>
        <ItemEditDialog
          item={item}
          open={dialogOpen}
          onClose={this.toggleDialog}
          onSubmit={onChange}
          addFormTitle={addFormTitle}
          editFormTitle={editFormTitle}
        />
        <Chip
          onClick={this.toggleDialog}
          onDelete={onDelete}
        >
          <Typography variant="caption" color="inherit" component="span">
            { moment().isoWeekday(item.weekDay).format('dddd') }
            {' '}
            { this.renderTime(item.startTimeMinute) }
            { !isNil(item.endTimeMinute) && ` - ${this.renderTime(item.endTimeMinute)}` }
          </Typography>
        </Chip>
      </Fragment>
    )
  }
}
